import authReducer from "store/slices/auth.slice";
import useReducer from "store/slices/user.slice";
import landingPageSlice from "./landingPage.slice";
import loginResponseSlice from "./loginResponse.slice";
import productSlice from "./product.slice";
import productCustomizationSlice from "./productCustomizationSlice";
import playerRoster from "./playerRoster.slice";
import lookupSlice from "./lookup.slice";
import UuidSlice from "./uuid.slice";

const reducer = {
  auth: authReducer,
  user: useReducer,
  landingPage: landingPageSlice,
  loginPageResponse: loginResponseSlice,
  product: productSlice,
  productCustomization: productCustomizationSlice,
  playerRoster: playerRoster,
  lookupSlice: lookupSlice,
  UuidSlice: UuidSlice,
};

export default reducer;
